import Portfolio from "../Entities/Portfolio";
import PageStyle from "../../Components/Enums/PageStyle";

const Pastels: Portfolio = {
    path: "pastels",
    name: "Pastels",
    pageStyle: PageStyle.Gray,
    pieces: [
        {image: "pastel-01.jpg", thumbAlt: "big apple", title: "Big Apple", size: "", pixelWidth: 236, pixelHeight: 360},
        {image: "pastel-02.jpg", thumbAlt: "emerging apple", title: "Emerging Apple", size: "", pixelWidth: 258, pixelHeight: 360},
        {image: "pastel-03.jpg", thumbAlt: "feather pear", title: "Feather Pear", size: "", pixelWidth: 258, pixelHeight: 360},
        {image: "pastel-04.jpg", thumbAlt: "five pears", title: "Five Pears", size: "", pixelWidth: 600, pixelHeight: 336},
        {image: "pastel-05.jpg", thumbAlt: "flying chili", title: "Flying Chili", size: "", pixelWidth: 600, pixelHeight: 336},
        {image: "pastel-06.jpg", thumbAlt: "giant pears", title: "Giant Pears", size: "", pixelWidth: 491, pixelHeight: 360},
        {image: "pastel-07.jpg", thumbAlt: "grandmother pear", title: "Grandmother Pear", size: "", pixelWidth: 251, pixelHeight: 360},
        {image: "pastel-08.jpg", thumbAlt: "heavenly bodies", title: "Heavenly Bodies", size: "", pixelWidth: 262, pixelHeight: 360},
        {image: "pastel-09.jpg", thumbAlt: "lemons", title: "Lemons", size: "", pixelWidth: 600, pixelHeight: 324},
        {image: "pastel-10.jpg", thumbAlt: "peach jam", title: "Peach Jam", size: "", pixelWidth: 507, pixelHeight: 360},
        {image: "pastel-11.jpg", thumbAlt: "peaches", title: "Peaches", size: "", pixelWidth: 600, pixelHeight: 237},
        {image: "pastel-12.jpg", thumbAlt: "three apples", title: "Three Apples", size: "", pixelWidth: 555, pixelHeight: 360},
    ],
    piecesColumns: 9,
    statementTitle: "Pastels",
    statement: {
        leftColumn: [
            "When I pick an apple or slice a pear, I delight in each fruit's smoothness, roundness, and possibility. I recognize the natural feminine form that holds the seed, births children, and nurtures others. It is an ideal, a testament to human potential. For me, fruit is ripe with hope, the future, wild nourishment, and connection.",
            "Here, I use pastels to explore each shape, to express its simplicity and glory. I’m playing with irreverent composition. Hard edges hug texture, soft ones suggest mystery. I'm working to hold a pure moment yet imply powerful movement.",
        ],
        rightColumn: [],
    },
};

export default Pastels;
